// @ts-strict-ignore
import Image from 'next/image'
import { useState } from 'react'
import type { Swiper as SwiperInstance } from 'swiper'
import 'swiper/css'
import 'swiper/css/a11y'
import 'swiper/css/free-mode'
import { Thumbs } from 'swiper/modules'
import { Swiper, SwiperSlide } from 'swiper/react'

import { SliderNextButton, SliderPrevButton } from '@/shared/ui/SliderButtons'

import { useProductSliderVideo } from '../../../hooks/useProductSliderVideo'
import { getMediaUrl, ProductSliderMedia } from '../../../media'
import { SliderPaginationDetailed } from '../slider-pagination-detailed/slider-pagination-detailed'
import { SliderPaginationSimple } from '../slider-pagination-simple/slider-pagination-simple'

import cl from './slider.module.scss'

type SliderProps = {
	media?: ProductSliderMedia[]
	activeIndex?: number
}

export const Slider = (props: SliderProps) => {
	const { media = [], activeIndex } = props
	const [thumbSwiper, setThumbSwiper] = useState<SwiperInstance | null>(null)
	const {
		activeSlide,
		setActiveSlide: handleSetActiveSlide,
		getVideoProps
	} = useProductSliderVideo({
		media,
		initialSlide: activeIndex ?? 0
	})
	return (
		<Swiper
			className={cl.swiper}
			modules={[Thumbs]}
			spaceBetween={1}
			slidesPerView={1}
			initialSlide={activeIndex || 0}
			loop
			thumbs={{ swiper: thumbSwiper }}
			onSlideChange={swiper => handleSetActiveSlide(swiper.realIndex)}>
			{media.map((item, index) => (
				<SwiperSlide key={`${item.type}-${item.src}`} className={cl.swiper__slide}>
					{item.type === 'image' ? (
						<div className={cl.image}>
							<Image src={getMediaUrl(item.src)} quality={100} fill alt="" draggable={false} />
						</div>
					) : (
						<div className={cl.videoWrapper}>
							<video className={cl.video} controls {...getVideoProps(index, item.src, item.poster)} />
						</div>
					)}
				</SwiperSlide>
			))}
			<div className={cl.buttons}>
				<SliderPrevButton className={cl.buttons__prevButton} />
				<SliderNextButton className={cl.buttons__nextButton} />
			</div>
			<SliderPaginationDetailed
				className={cl.paginationDetailed}
				media={media}
				activeIndex={activeSlide}
				setActiveIndex={handleSetActiveSlide}
				onSwiper={setThumbSwiper}
			/>
			<SliderPaginationSimple className={cl.paginationSimple} count={media.length} activeIndex={activeSlide} />
		</Swiper>
	)
}
